import { getStreamsForUser, callGoogleCalendarLogin, callGoogleCalendarSyncEndpoint, exportEventsToICal,
  getCourses, deleteFromStream, updateEntityInStream, getCoursePlanningStructure } from '../api'

export const populateCourses = ({ state, commit }, {streamUuid, currentYear, currentSemester}) => {
  if (streamUuid) {
    return getCourses(streamUuid, currentYear, currentSemester).then((response) => {
      commit('LOAD_COURSES', response)
      return response
    })
  }
  return []
}

export const clearCourses = ({ state, commit }) => {
  commit('CLEAR_COURSES')
}

export const populateStreamsForUser = ({ state, commit }, {userId}) => {
  return getStreamsForUser(userId).then((response) => {
    commit('LOAD_STREAMS', response)
    return response
  })
}

export const populateAllStreamCourses = ({ state, commit }, {streamUuid, updateTimeStamp}) => {
  return getCoursePlanningStructure(streamUuid).then((response) => {
    if (!response) {
      return []
    }
    let streamCourses = []
    Object.keys(response).sort().forEach(key => {
      let substream = response[key]
      substream.forEach(stream => {
        let course = stream.course ? stream.course : stream
        streamCourses.push(course)
      })
    })
    commit('LOAD_COURSE_PLANNING_STREAM', response)
    commit('LOAD_COURSES', streamCourses)
    if (updateTimeStamp) {
      commit('UPDATE_SEMESTER_TIME_STAMP', new Date())
    }
    return streamCourses
  })
}

export const removeCourseFromStream = ({ state, commit }, {streamUuid, currentYear, currentSemester, courseData, entityType, userRole}) => {
  const sendMessageToChannel = userRole === 'Advisor'
  return deleteFromStream(streamUuid, currentYear, currentSemester, courseData, entityType, sendMessageToChannel).then((response) => {
    if (state.courses.includes(courseData)) {
      commit('DELETE_COURSE', courseData)
    }
    return response
  })
}

export const removeFromStream = ({ state, commit }, {streamUuid, currentYear, currentSemester, objectData, entityType, userRole}) => {
  const sendMessageToChannel = userRole === 'Advisor'
  return deleteFromStream(streamUuid, currentYear, currentSemester, objectData, entityType, sendMessageToChannel).then((response) => {
    return response
  })
}

export const editEntityInStream = ({ state, commit }, {streamUuid, currentYear, currentSemester, objectData, entityType}) => {
  return updateEntityInStream(streamUuid, currentYear, currentSemester, objectData, entityType).then((response) => {
    return response
  })
}

export const getICalFile = ({ state, commit }, {streamUuid, currentYear, currentSemester}) => {
  return exportEventsToICal(streamUuid, currentYear, currentSemester).then((response) => {
    commit('LOAD_ICAL_FILE', response)
    return response
  })
}

export const loginToGoogleCalendar = ({ state, commit }) => {
  return callGoogleCalendarLogin().then((urlResponse) => {
    return urlResponse
  })
}

export const syncWithGoogleCalendar = ({ state, commit }, {streamUuid, currentYear, currentSemester, googleOAuthToken}) => {
  return callGoogleCalendarSyncEndpoint(streamUuid, currentYear, currentSemester, googleOAuthToken).then((response) => {
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/semester/vuex/actions.js